import { Backdrop, BackdropProps } from '@mui/material';
import { useEffect } from 'react';

function RfeBackdrop(props: BackdropProps) {
	useEffect(() => {
		const topWindow = $.iframe.topWindow();
		const webDialog = topWindow.WebDialog;
		const contentStyle = topWindow.document.getElementById('rfeContent').style;
		contentStyle.position = 'relative';
		contentStyle.zIndex = '93000';
		webDialog.displayBackdrop();

		return () => {
			webDialog.hide();
			contentStyle.position = 'static';
			contentStyle.zIndex = '92999';
		};
	}, []);

	return <Backdrop {...props}></Backdrop>;
}

export default RfeBackdrop;
